import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { useSite } from "../../context/SiteContext";

export default function FloatingWa() {
  const { contact: CONTACT } = useSite();
  return (
    <motion.a href={CONTACT.whatsapp} target="_blank" rel="noreferrer" aria-label="WhatsApp" data-testid="floating-whatsapp-btn"
      initial={{ scale: 0, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ delay: 2, type: "spring" }}
      whileHover={{ scale: 1.08 }} whileTap={{ scale: 0.95 }}
      className="fixed bottom-5 right-5 z-50 grid h-14 w-14 place-items-center rounded-full bg-[#25D366] text-white shadow-[0_10px_40px_rgba(37,211,102,0.4)]">
      <MessageCircle size={26} />
    </motion.a>
  );
}
